// export const  wordpressUrl = 'https://www.docspro.in/server/';
export const  wordpressUrl = 'https://admin.docspro.in/';